import Hotel from './Hotel';
import moment from 'moment';
import { CUSTOM_PRICE } from '../constants/Define';
import { getMomentDate } from './../utils/commonUtils';

export default class CustomPrice {
    constructor(data={}){
        this.setData(data)
    }

    setData(data){
        this.id = data.id !== undefined ? data.id : undefined;
        this.name = data.name || undefined;
        this.setType(data.calculationType || undefined);
        this.value = data.calculationValue || 0;
        this.hotel = this.getHotel(data);
        this.startDate = getMomentDate(data.startDate);
        this.endDate = getMomentDate(data.endDate);
        this.isActive = data.isActive !== undefined ? data.isActive : true;
    }

    setType(type) {
        if (!type) type = CUSTOM_PRICE.CALCULATE_TYPE.AMOUNT;
        this.type = CUSTOM_PRICE.CALCULATE_TYPE[type.toUpperCase()] || type;
    }

    getHotel(data){
        if(!data) return this.hotel;
        return new Hotel({id: data.hotelId, name: data.hotelName});
    }

    export(){
        return {
            id: this.id,
            name: this.name,
            calculationType: this.type,
            calculationValue: Number(this.value),
            hotelId: this.hotel && this.hotel.id,
            startDate: this.startDate && this.startDate.toISOString(),
            endDate: this.endDate && this.endDate.toISOString(),
            isActive: this.isActive,
        }
    }

}